/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "relocate-28b59dc8--sprite",
  "use": "relocate-28b59dc8--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"relocate-28b59dc8--sprite\"><path d=\"M0,0H36V36H0Z\" fill=\"none\" /><g transform=\"translate(-562.21 -3246.629)\"><path d=\"M583.32,3258.63v12a2,2,0,0,1-2,2h-7.11a2,2,0,0,1-2-2v-5.04h7.02l-2.58,2.57a1,1,0,0,0,0,1.41.978.978,0,0,0,1.41,0l4.95-4.94-4.95-4.95a.979.979,0,0,0-1.41,0,1,1,0,0,0,0,1.41l2.5,2.5h-6.94v-4.96a2,2,0,0,1,2-2h7.11A2,2,0,0,1,583.32,3258.63Z\" fill=\"currentColor\" /><rect width=\"2.89\" height=\"16\" rx=\"1.445\" transform=\"translate(585.32 3256.63)\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
